// [BD feat] Category List (featured-links "reveal" layout) — bd-category-list.js
// Figma (1649:9286 desktop / 1649:9946 mobile) activates exactly one category by
// click: the clicked row becomes active, its image is shown, and the round arrow
// button becomes the only way to navigate to it — no hover preview, on any
// pointer type. Independent of the theme's own FeaturedLinks custom element
// (hover/cursor-follow driven, in theme.js): this section no longer renders any
// of the elements that element's listener looks for, so the two never collide.
(function () {
  'use strict';

  // [BD feat] The preview's CSS `top` is only a pre-JS fallback (tuned for
  // row 1). To actually track the active row, measure its real vertical
  // center and set the preview's `top` so the preview's own center lands on
  // that same line — e.g. activating the 3rd link centers the preview on
  // the 3rd row, regardless of that row's real height/padding.
  function updatePreviewOffset(root, link) {
    var preview = root.querySelector('.bd-category-list__preview');
    if (!preview || !link) return;

    var rootRect = root.getBoundingClientRect();
    var linkRect = link.getBoundingClientRect();
    var previewHeight = preview.getBoundingClientRect().height;

    var linkCenter = linkRect.top + linkRect.height / 2;
    var previewTop = linkCenter - previewHeight / 2 - rootRect.top;

    preview.style.top = previewTop + 'px';
  }

  function activate(root, blockId) {
    var link = root.querySelector('.bd-category-list__link[data-block-id="' + blockId + '"]');
    if (!link) return;

    root.querySelectorAll('.bd-category-list__link').forEach(function (item) {
      var isActive = item === link;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    updatePreviewOffset(root, link);

    var image = root.querySelector('.bd-category-list__preview-image');
    var imageUrl = link.getAttribute('data-image');
    if (image && imageUrl) {
      // Drop srcset/sizes: browsers prioritize srcset over src, so a stale
      // srcset from the previously-active image would keep winning otherwise.
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = imageUrl;
      image.alt = link.getAttribute('data-aria-label') || '';
    }

    var arrow = root.querySelector('[data-category-arrow]');
    if (arrow) {
      arrow.setAttribute('href', link.getAttribute('href'));
      arrow.setAttribute('aria-label', link.getAttribute('data-aria-label') || '');
    }
  }

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;

    scope.querySelectorAll('featured-links.bd-category-list').forEach(function (root) {
      if (root.hasAttribute('data-bd-category-list-init')) return;
      root.setAttribute('data-bd-category-list-init', '');

      root.querySelectorAll('.bd-category-list__link').forEach(function (link) {
        link.addEventListener('click', function (event) {
          event.preventDefault();
          activate(root, link.getAttribute('data-block-id'));
        });
      });

      // Position the preview against the row that's server-rendered active
      // (always the first block) instead of relying on the CSS fallback.
      var initialActive = root.querySelector('.bd-category-list__link.is-active') || root.querySelector('.bd-category-list__link');
      if (initialActive) updatePreviewOffset(root, initialActive);

      // Row heights differ between the mobile and desktop rhythms (and on
      // any reflow), so re-measure the active row's offset on resize.
      var resizeFrame = null;
      window.addEventListener('resize', function () {
        if (resizeFrame) return;
        resizeFrame = window.requestAnimationFrame(function () {
          resizeFrame = null;
          var activeLink = root.querySelector('.bd-category-list__link.is-active');
          if (activeLink) updatePreviewOffset(root, activeLink);
        });
      });

      if (window.Shopify && Shopify.designMode) {
        root.addEventListener('shopify:block:select', function (event) {
          if (event.target && event.target.hasAttribute('data-block-id')) {
            activate(root, event.target.getAttribute('data-block-id'));
          }
        });
      }
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.bd-category-list')) return;
    initScope(event.target);
  });
})();
// [/BD feat] Category List (featured-links "reveal" layout)
